module.exports = __webpack_public_path__ + "img/full0-min.655c4ffe.png";